import * as React from "react";
import { Topic } from "dialup";
import { connect } from "react-redux";
import { RootState } from "../types";

interface IProps {
  disabled?: boolean;
  topicList: string[];
  topicData: { [key: string]: Topic };
  onSelect?: (id: Topic | undefined) => any;
}

interface IState {
  selectedID?: string;
}

class TopicPicker extends React.Component<IProps, IState> {
  public state = {} as IState;

  public render() {
    const { topicList, disabled } = this.props;
    const { selectedID } = this.state;
    return (
      <div>
        <select
          value={selectedID || ""}
          onChange={this.onSelect}
          disabled={disabled}
          className="form-control"
        >
          <option value="">No Topic</option>
          {topicList.map(this.renderTopicOption)}
        </select>
        {selectedID ? this.renderTopic(selectedID) : null}
      </div>
    );
  }

  private renderTopic = (topicID: string) => {
    const { topicData } = this.props;
    const topic = topicData[topicID];
    if (!topic) {
      return null;
    }
    const { promptURL, text } = topic;
    return (
      <div>
        {promptURL ? (
          <audio className="prompt-audio" controls={true} src={promptURL} />
        ) : null}
        {text ? (
          <div className="form-group">
            <textarea
              disabled={true}
              placeholder="Prompt Text"
              value={text}
              className="form-control"
            />
          </div>
        ) : null}
      </div>
    );
  };

  private renderTopicOption = (id: string) => {
    const { topicData } = this.props;
    const topic = topicData[id];
    return (
      <option key={id} value={id}>
        {topic.name}
      </option>
    );
  };

  private onSelect = (e: React.FormEvent<HTMLSelectElement>) => {
    const { topicData, onSelect } = this.props;
    const { selectedOptions } = e.currentTarget;

    let selectedID: string | undefined;
    if (selectedOptions.length > 0) {
      selectedID = selectedOptions[0].value;
    }

    this.setState({
      selectedID,
    });

    if (onSelect) {
      onSelect(selectedID ? topicData[selectedID] : undefined);
    }
  };
}

const TopicPickerContainer = connect(
  ({ topics }: RootState) => ({
    topicList: topics.list,
    topicData: topics.data,
  }),
  () => ({})
)(TopicPicker);

export default TopicPickerContainer;



// WEBPACK FOOTER //
// ./src/components/TopicPicker.tsx